const TranslationPrefix = {
    BILLING: "billing",
    COMPETENCIES: "competencies",
    CP_MENU: "cp_menu",
    FILTER_MENU: "cp_filter_menu",
    FORM: "form",
    HEADER: "header",
    HOME: "cp_home",
    PARTICIPANTS: "cp_participants",
    QUESTIONNAIRES: "questionnaires",
    REQUEST_ASSESSMENT: "cp_request_assessment",
    SETTINGS: "cp_company_settings",
    TALENT_ANALYTICS: "cp_talent_analytics",
    TEAMS: "cp_teams",
    TOUR: "tour",
};

export default TranslationPrefix;
